var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36C22.34 36 20.78 35.685 19.32 35.055C17.86 34.425 16.59 33.57 15.51 32.49C14.43 31.41 13.575 30.14 12.945 28.68C12.315 27.22 12 25.66 12 24C12 22.34 12.315 20.78 12.945 19.32C13.575 17.86 14.43 16.59 15.51 15.51C16.59 14.43 17.86 13.575 19.32 12.945C20.78 12.315 22.34 12 24 12C25.3 12 26.53 12.19 27.69 12.57C28.85 12.95 29.92 13.48 30.9 14.16L29.16 15.93C28.4 15.45 27.59 15.075 26.73 14.805C25.87 14.535 24.96 14.4 24 14.4C21.34 14.4 19.075 15.335 17.205 17.205C15.335 19.075 14.4 21.34 14.4 24C14.4 26.66 15.335 28.925 17.205 30.795C19.075 32.665 21.34 33.6 24 33.6C26.66 33.6 28.925 32.665 30.795 30.795C32.665 28.925 33.6 26.66 33.6 24C33.6 23.64 33.58 23.28 33.54 22.92C33.5 22.56 33.44 22.21 33.36 21.87L35.31 19.92C35.53 20.56 35.7 21.22 35.82 21.9C35.94 22.58 36 23.28 36 24C36 25.66 35.685 27.22 35.055 28.68C34.425 30.14 33.57 31.41 32.49 32.49C31.41 33.57 30.14 34.425 28.68 35.055C27.22 35.685 25.66 36 24 36ZM22.32 29.52L17.22 24.42L18.9 22.74L22.32 26.16L34.32 14.13L36 15.81L22.32 29.52Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon2);
export default __webpack_public_path__ + "static/media/taskicon2.3832d034bd4af1b05778630a6d6292e8.svg";
export { ForwardRef as ReactComponent };